module.exports = __webpack_public_path__ + "img/getting-started.0f5b00af.png";